import Text from "hardcover-ui/components/Text";
import pluralize from "lib/pluralize";
import { oxfordCommaList } from "lib/array";
import LocaleNumber from "components/ui/LocaleNumber";
import LocalizedDate from "components/shared/LocalizedDate";
import { SeriesSerializersSeriesGroup } from "types/serializers";

export default function AboutSeries({ series }: { series: SeriesSerializersSeriesGroup }) {
  return (
    <Text variant="secondary" as="p">
      {series.name} is a{" "}
      <b><LocaleNumber number={series.releasedBooksCount} />-book series</b>{" "}
      {series.releasedBooksCount > 1 && series.primaryReleasedBooksCount ? (
        <>
          with{" "}
          <b>{series.primaryReleasedBooksCount} {pluralize("released primary work", series.primaryBooksCount)}</b>{" "}
        </>
      ) : (
        <></>
      )}
      {series.firstReleaseYear && <>first released in {series.firstReleaseYear} </>}
      {series.topAuthorNames.length > 0 && (
        <>with contributions by {oxfordCommaList(series.topAuthorNames)}</>
      )}
      .
      {series.unrelesedBooksCount > 0 && (
        <>{" "}
          <b>
            <LocaleNumber number={series.unrelesedBooksCount} />{" "}
            {pluralize("book", series.unrelesedBooksCount)}
          </b>{" "}
          {series.unrelesedBooksCount === 1 ? "is" : "are"} still to be released.
        </>
      )}
      {series.nextReleaseDate && (
        <>
          {" "}
          The next book is scheduled for release on{" "}
          <LocalizedDate date={series.nextReleaseDate} />.
        </>
      )}
    </Text>
  );
}
